'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('components');

var _reactRouter = require('react-router');

var _booking = require('redux/modules/booking');

var bookingActions = _interopRequireWildcard(_booking);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ManageBookingRequest = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    bookingRequests: state.booking.bookingRequests,
    cancelBooking: state.booking.cancelBooking,
    cancelBookingError: state.booking.cancelBookingError,
    toggleCancelError: state.booking.toggleCancelError,
    toggleCancelSuccess: state.booking.toggleCancelSuccess
  };
}, {
  loadAllBookingRequest: bookingActions.loadAllBookingRequest,
  cancelBookingRequest: bookingActions.cancelBookingRequest
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(ManageBookingRequest, _Component);

  function ManageBookingRequest() {
    var _ref, _context;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ManageBookingRequest);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ManageBookingRequest.__proto__ || (0, _getPrototypeOf2.default)(ManageBookingRequest)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      BUTTONS: [{
        text: 'Xem chi tiết',
        action: (_context = _this).toBookingDetail.bind(_context),
        iconUrl: '/booking/details.png'
      }, {
        text: 'Hủy đặt chỗ này',
        action: (_context = _this).cancelBookingRequest.bind(_context),
        iconUrl: '/booking/cancel.png'
      }, { text: 'Bỏ qua', action: (_context = _this).hideMenu.bind(_context) }],
      bookingRequestId: '',
      info: { title: {}, message: [] },
      showMenu: false,
      showInfo: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ManageBookingRequest, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var loadAllBookingRequest = this.props.loadAllBookingRequest;

      loadAllBookingRequest();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var loadAllBookingRequest = nextProps.loadAllBookingRequest,
          cancelBooking = nextProps.cancelBooking,
          cancelBookingError = nextProps.cancelBookingError;

      if (this.props.toggleCancelSuccess !== nextProps.toggleCancelSuccess && nextProps.cancelBooking) {
        var title = { text: 'Thông báo', type: 'success' };
        var message = [{ text: cancelBooking.message }];
        this.hideMenu();
        this.showInfo(title, message);
        loadAllBookingRequest();
      }
      if (this.props.toggleCancelError !== nextProps.toggleCancelError && nextProps.cancelBookingError) {
        var _title = { text: 'Thông báo', type: 'error' };
        var _message = [{ text: cancelBookingError.message }];
        this.showInfo(_title, _message);
      }
    }
  }, {
    key: 'hideMenu',
    value: function hideMenu() {
      this.setState({ showMenu: false });
    }
  }, {
    key: 'showMenu',
    value: function showMenu() {
      this.setState({ showMenu: true });
    }
  }, {
    key: 'showInfo',
    value: function showInfo(title, message, button) {
      var info = {};
      if (title) {
        info.title = title;
      }
      if (message) {
        info.message = message;
      }
      if (button) {
        info.button = button;
      }
      this.setState({ info: info, showInfo: true });
    }
  }, {
    key: 'hideInfo',
    value: function hideInfo() {
      this.setState({ showInfo: false });
    }
  }, {
    key: 'onMore',
    value: function onMore(v) {
      this.setState({ bookingRequestId: v.bookingRequestId });
      this.showMenu();
    }
  }, {
    key: 'onClick',
    value: function onClick(v) {
      var bookingRequestId = v.bookingRequestId;

      _reactRouter.browserHistory.push('/lich-hen/' + bookingRequestId);
    }
  }, {
    key: 'toBookingDetail',
    value: function toBookingDetail() {
      var bookingRequestId = this.state.bookingRequestId;

      _reactRouter.browserHistory.push('/lich-hen/' + bookingRequestId);
    }
  }, {
    key: 'cancelBookingRequest',
    value: function cancelBookingRequest() {
      var _this2 = this;

      var cancelBookingRequest = this.props.cancelBookingRequest;
      var bookingRequestId = this.state.bookingRequestId;

      var title = { text: 'Thông báo', type: 'warn' };
      var message = [{ text: 'Bạn có chắc là muốn hủy đặt chỗ này?' }];
      var button = [{
        text: 'Hủy',
        type: 'danger',
        onClick: function onClick() {
          return cancelBookingRequest(bookingRequestId);
        }
      }, { text: 'Thoát', type: 'default', onClick: function onClick() {
          return _this2.hideInfo();
        } }];
      this.showInfo(title, message, button);
      this.hideMenu();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./ManageBookingRequest.scss');
      var _state = this.state,
          showMenu = _state.showMenu,
          BUTTONS = _state.BUTTONS,
          info = _state.info,
          showInfo = _state.showInfo;
      var bookingRequests = this.props.bookingRequests;

      return _react2.default.createElement(
        'div',
        { className: styles.container },
        bookingRequests && bookingRequests.length > 0 ? _react2.default.createElement(
          'div',
          { className: styles.content },
          bookingRequests.map(function (v, i) {
            return _react2.default.createElement(_components.CardBookingRequest, (0, _extends3.default)({
              className: styles.card,
              key: 'card_' + i
            }, v, {
              onMore: function onMore() {
                return _this3.onMore(v);
              },
              onClick: function onClick() {
                return _this3.onClick(v);
              }
            }));
          })
        ) : _react2.default.createElement(
          'div',
          { className: styles.emptyContent },
          _react2.default.createElement(
            'div',
            { className: styles.emptyList },
            'Ch\u01B0a c\xF3 l\u1ECBch h\u1EB9n!'
          )
        ),
        _react2.default.createElement(
          _components.MenuOptions,
          {
            show: showMenu,
            data: BUTTONS,
            title: 'Tùy chọn',
            onHide: this.hideMenu.bind(this)
          },
          _react2.default.createElement(
            'div',
            { className: styles.menuBox },
            BUTTONS && BUTTONS.map(function (v) {
              return _react2.default.createElement(
                'div',
                { className: styles.option, onClick: v.action },
                v.iconUrl ? _react2.default.createElement('img', { className: styles.icon, src: v.iconUrl, alt: '' }) : _react2.default.createElement('div', { className: styles.icon }),
                v.text
              );
            })
          )
        ),
        _react2.default.createElement(_components.ModalCustom, {
          show: showInfo,
          onHide: this.hideInfo.bind(this),
          title: info.title,
          message: info.message,
          button: info.button,
          closeButton: true
        })
      );
    }
  }]);
  return ManageBookingRequest;
}(_react.Component), _class2.propTypes = {
  // @data
  bookingRequests: _react.PropTypes.array,
  cancelBooking: _react.PropTypes.object,
  cancelBookingError: _react.PropTypes.object,
  toggleCancelError: _react.PropTypes.bool,
  toggleCancelSuccess: _react.PropTypes.bool,
  // @action
  loadAllBookingRequest: _react.PropTypes.func,
  cancelBookingRequest: _react.PropTypes.func
}, _temp2)) || _class);
exports.default = ManageBookingRequest;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Booking/ManageBookingRequest.js
// module id = 1533
// module chunks = 0